const FOCUSABLE_SELECTOR =
  'input:not([disabled]):not([type="hidden"]):not([type="checkbox"]), textarea:not([disabled]), [contenteditable="true"]';

/** Elements inside containers marked with data-skip-tab are excluded */
const isSkippable = (el: HTMLElement): boolean =>
  !!el.closest('[data-skip-tab]');

/**
 * Moves focus to the next or previous worksheet input, skipping non-input
 * elements (buttons, headers, labels) and inputs removed from the tab order
 * (`tabindex="-1"`, e.g. read-only worksheet values) — otherwise Tab would pause
 * on an invisibly-focused read-only row between two editable ones. Call this
 * from any keydown handler that intercepts Tab so native tab order doesn't
 * escape the worksheet.
 */
export const navigateWorksheetTab = (
  currentEl: HTMLElement,
  reverse: boolean
): void => {
  const focusables = Array.from(
    document.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR)
  ).filter((el) => !isSkippable(el) && el.tabIndex !== -1);
  const idx = focusables.indexOf(currentEl);
  (reverse ? focusables[idx - 1] : focusables[idx + 1])?.focus();
};
